import { render, staticRenderFns } from "./MemoryGame.vue?vue&type=template&id=427fea34&"
import script from "./MemoryGame.vue?vue&type=script&lang=ts&"
export * from "./MemoryGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports